import { EventApi, IdentifyApi } from 'api'
import { getStoreState } from 'config/store'
import { PageTrackEventAttributes } from 'modules/api/types'
import { getEmbedId, getEmbedPathOr, getInboxId } from 'modules/embed/selectors'
import { getOrgId } from 'modules/embed/utils'
import { ERROR } from 'modules/logging/errors'
import { getEndUser, getExternalId, getLeadId, getSessionContext, getUserAgent } from 'modules/session/selectors'
import { CustomAttributes, Identity } from 'types/user'
import { log, warn } from 'utils'



export const trackPageEvent = (attributes: PageTrackEventAttributes) => {
  try {
    trackEvent('Page', attributes)
  } catch(err) {
    warn([ERROR.EVENT_SEND.PAGE, err])
  }
}

export const trackEvent = (event: string, attributes: object) => {
  const state = getStoreState()

  const orgId = getOrgId()
  const userId = getExternalId(state)
  const userAgent = getUserAgent(state)
  const inboxId = getInboxId(state)
  const anonymousId = getLeadId(state)
  const embedId = getEmbedPathOr('',['id'])

  EventApi.post('/track', {
    orgId,
    inboxId,
    userId,
    attributes,
    event,
    embedId,
    context: {
      userAgent
    },
    anonymousId
  }).catch((error)=>{
    warn([ERROR.EVENT_SEND.PAGE, error])
  })
}

export const updateEndUserIdentity = (attributes: CustomAttributes, userId: any = null, options: Record<string, any>) => {
  const state = getStoreState()
  const pageContext = getSessionContext(state)
  const { leadId } = getEndUser(state)
  const { userJwt: signedIdentity } = options || {}


  const body: Partial<Identity> = {
    attributes,
    userId: null,
    anonymousId: leadId,
    context: pageContext,
    orgId: getOrgId().toString(),
    signedIdentity,
    embedId: getEmbedId(state)
  }

  if (userId) {
    body.userId = userId
  }

  return IdentifyApi.post(`/identify`, body)
    .catch((err) => {
      if(!!err.response && err.response.status === 402) {
        log({ type: 'warn', data: ['Unable to identify due to suspended org'] })
      } else {
        warn([`Failed to identify user via API - ${err.message}`])
      }
    })
}
